export default "__VITE_ASSET__cF3N$iKX__"